export enum EPeridoCodigo {
    manha = 1,
    tarde = 2,
    integral = 3
}

export const EPeriodoNome = [
    {
        key:"manha",
        description:"Manhã"        
    },
    {
        key:"tarde",
        description:"Tarde"        
    },
    {
        key:"integral",
        description:"Integral"        
    },    
]

